import React from 'react'
import tankImage from "../../../images/products/C.png"
import HeaderTopS3 from '../../../components/HeaderTopS3/HeaderTopS3'
import NavbarS3 from '../../../components/NavbarS3/NavbarS3'
import Logo from '../../../images/snbs_logo1.png'
import PageTitle from '../../../components/pagetitle/PageTitle'
import Footer from '../../../components/footer/Footer'
import Img from '../../../images/home/p-1.jpg'

function MulticolorBag() {

 const values = [
  {
    number: 1,
    text: "Attractive printing – High-resolution multicolor printing for strong shelf appeal and brand visibility.",
  },
  {
    number: 2,
    text: "Moisture resistant – BOPP lamination protects contents from moisture, dust, and external damage.",
  },
  {
    number: 3,
    text: "High strength – Strong woven base ensures durability and tear resistance during transport.",
  },
  {
    number: 4,
    text: "Customizable – Available in various sizes, finishes (glossy/matte), and handle styles.",
  },
  {
    number: 5,
    text: "Food grade – Safe for packing edible items like rice, flour, sugar, and pulses.",
  },
  {
    number: 6,
    text: "Reusable – Durable material allows multiple uses, reducing environmental waste.",
  },
  {
    number: 7,
    text: "Eco-friendly – Made using recyclable materials to support sustainability.",
  },
  {
    number: 8,
    text: "Multi-industry use – Ideal for packaging agro-products, pet food, fertilizers, and more.",
  },
];

  return (
    <>
     <HeaderTopS3 />
     <NavbarS3 hclass={'wpo-site-header wpo-header-style-3'} Logo={Logo} />
      <PageTitle pageTitle={'BOPP Multicolor Bag'} pagesub={'Products'} Img={Img} />
      <section className="container pt-100">
      <div className="row align-items-center">
        {/* Left Column - Text */}
        <div className="col-lg-6 col-md-12 col-sm-12 text-center">
          <img
            src={tankImage}
            alt="Water Tank" />
        </div>

        {/* Right Column - Image */}
       <div className="col-lg-6 col-md-12 col-sm-12 mb-4">
  <h2 className="fw-bold mb-3">Bold Prints. Strong Packaging.</h2>
  <p style={{ textAlign: "justify" }}>
    BOPP (Biaxially Oriented Polypropylene) multicolor bags are a premium packaging solution combining strength with visual appeal. Widely used in industries like agriculture, food, and retail, these bags help your brand stand out while protecting your product.
  </p>
  <p style={{ textAlign: "justify" }}>
    At SNBS, we manufacture high-quality BOPP laminated woven bags with vibrant multicolor printing. These bags offer excellent tear resistance, moisture protection, and load-bearing capacity. The BOPP film allows for photographic-quality printing, enhancing brand visibility and shelf appeal.
  </p>
  <p style={{ textAlign: "justify" }}>
    Available in various sizes, finishes (matte/glossy), and handle options, our BOPP bags are ideal for packing products like rice, flour, fertilizers, pet food, and more. With durability, branding, and performance in one package—they're a smart and stylish packaging choice.
  </p>
</div>

      </div>
    </section>
 {/* <div className="container pt-100 pb-100">
      <h2 className="text-center fw-bold mb-4">BOPP Multicolor Bag</h2>
      <div className="table-responsive">
        <table className="table table-bordered text-center mb-4">
          <thead className="table-primary">
            <tr>
              <th colSpan="5" className="bg-primary text-white">
               BOPP Multicolor Bag available in various liters
              </th>
            </tr>
            <tr>
              <th>Liter</th>
              <th>3000</th>
              <th>5000</th>
              <th>7500</th>
              <th>10000</th>
            </tr>
          </thead>
        </table>

        <table className="table table-bordered text-center">
          <thead className="table-primary">
            <tr>
              <th colSpan="5" className="bg-primary text-white">
                PP Fabric Size Chart
              </th>
            </tr>
          </thead>
          <tbody>
            <tr className="table-light">
              <th>Size</th>
              <th>3000</th>
              <th>5000</th>
              <th>7500</th>
              <th>10000</th>
            </tr>
            <tr className="table-light">
              <th>Height (mm)</th>
              <td>1850</td>
              <td>2070</td>
              <td>2650</td>
              <td>3050</td>
            </tr>
            <tr className="table-light">
              <th>Diameter (mm)</th>
              <td>1550</td>
              <td>1870</td>
              <td>1940</td>
              <td>2120</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div> */}
<section style={{backgroundColor:"#f3f3f6"}}>
   <div className="container pt-100 pb-100" >
      <h2 className="text-center fw-bold mb-4">Product Features</h2>
      <div className="row">
        {values.map((item, index) => (
          <div key={index} className="col-md-6 mb-4 d-flex">
            <div
              className="rounded-circle bg-dark text-white d-flex align-items-center justify-content-center me-3"
              style={{ width: "40px", height: "40px", flexShrink: 0 }}>
              {item.number}
            </div>
            <p className="mb-2">{item.text}</p>
          </div>
        ))}
      </div>
    </div>
 </section>
    <Footer hclass={'wpo-site-footer mt-0'} upperContactArea={true} />
    </>
  )
}

export default MulticolorBag